import AccordionBox from "../../../../../../components/AccordionBox";
import {
  RazorDateTime,
  RazorImageFallback,
} from "../../../../../../components/razor-reuse";
import { ALL_ICONS } from "../../../../../../assets/icons/AllIcons";
import { labelClass, valueClass } from "../OverviewComponent";
import CurrencyText from "../../../../../../components/fragment/cur-text/CurrencyText";
import ZoomableImage from "../../../../../../components/fragment/image/zoomable-image";
import { useOverviewContext } from "../../../CustomerSingle";
import { useSelector } from "react-redux";
import RootState from "../../../../../../redux/type";

export default function KycAccordOne() {
  const context = useOverviewContext();
  const { customer } = useSelector((state: RootState) => state.customer);

  const filteredId = customer?.documents?.filter(
    (vals: any) =>
      vals?.document_type === "PASSPORT" ||
      vals?.document_type === "ID_CARD" ||
      vals?.document_type === "RESIDENCE_PERMIT" ||
      vals?.document_type === "DRIVERS_LICENCE" ||
      vals?.document_type === "DRIVERS",
  );

  const filteredSelfie = customer?.documents?.filter(
    (vals: any) => vals?.document_type === "SELFIE",
  );

  return (
    <>
      <AccordionBox defaultState={false} title="KYC Level 1">
        <main className="bg-white min-h-[500px] p-[24px] space-y-[18px]">
          <div className="inline-flex gap-x-[30px]">
            <h6 className="text-[16px] font-medium text-[#596080]">
              Individual Transaction: 1,000 Maximum
            </h6>
            <h6 className="text-[16px] font-medium text-[#596080]">
              Monthly Limit: 2,000 Maximum
            </h6>
          </div>
          <div className="flex w-full gap-x-[20px]">
            <div className="border border-[#e6e6e6] rounded-lg py-[14px] p-[34px] flex-1">
              <h6 className="text-[14px] font-medium text-gray-01 mb-[20px]">
                Personal Information
              </h6>
              <div className="size-[60px] bg-white-01 rounded-full grid place-content-center overflow-hidden profile-img-box">
                <RazorImageFallback
                  loadSize={45}
                  url={customer?.profile_picture || ""}
                >
                  <figure className="size-[80%] translate-y-[1.25rem] ">
                    {ALL_ICONS?.profile_img}
                  </figure>
                </RazorImageFallback>
              </div>
              <div className="grid gap-y-[20px] gap-x-[12px] grid-cols-2 mt-[20px]">
                <div className="space-y-2">
                  <h5 className={labelClass}>First Name:</h5>
                  <p className={valueClass}>{customer?.first_name || "---"}</p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Middle Name:</h5>
                  <p className={valueClass}>
                    {customer?.kyc?.middle_name || "---"}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Last Name:</h5>
                  <p className={valueClass}>{customer?.last_name || "---"}</p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Phone:</h5>
                  <p className={valueClass}>{customer?.phone || "---"}</p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Email:</h5>
                  <p className={valueClass}>{customer?.email || "---"}</p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Occupation:</h5>
                  <p className={valueClass}>
                    {customer?.kyc?.occupation || "---"}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Date of Birth:</h5>
                  <p className={valueClass}>{customer?.kyc?.dob || "---"}</p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Gender:</h5>
                  <p className={valueClass}>{customer?.kyc?.gender || "---"}</p>
                </div>
              </div>
            </div>
            <div className="border border-[#e6e6e6] rounded-lg py-[14px] p-[34px] flex-1">
              <h6 className="text-[14px] font-medium text-gray-01 mb-[20px]">
                Address Information
              </h6>
              <div className="grid gap-y-[20px] gap-x-[12px] grid-cols-2 mt-[20px]">
                <div className="space-y-2">
                  <h5 className={labelClass}>Country of Residence:</h5>
                  <p className={valueClass}>
                    {customer?.resident_country ? (
                      <CurrencyText
                        currency={customer?.resident_country?.iso_code}
                        url={customer?.resident_country?.flag_url}
                        text={customer?.resident_country?.name}
                      />
                    ) : (
                      "---"
                    )}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Country of Nationality:</h5>
                  <p className={valueClass}>
                    {customer?.nationality_country ? (
                      <CurrencyText
                        currency={customer?.nationality_country?.iso_code}
                        url={customer?.nationality_country?.flag_url}
                        text={customer?.nationality_country?.name}
                      />
                    ) : (
                      "---"
                    )}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>State/Region:</h5>
                  <p className={valueClass}>
                    {customer?.kyc?.state?.name || "---"}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>City:</h5>
                  <p className={valueClass}>
                    {customer?.kyc?.city?.name || "---"}
                  </p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Zip Code:</h5>
                  <p className={valueClass}>{customer?.kyc?.zip || "---"}</p>
                </div>
                <div className="space-y-2">
                  <h5 className={labelClass}>Home Address:</h5>
                  <p className={valueClass}>
                    {customer?.kyc?.home_address || "---"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="border border-[#e6e6e6] rounded-lg pb-[60px]">
            <div className="flex justify-between items-center border-[#e6e6e6] border-b py-[14px] px-[35px]">
              <p className="text-gray-01 text-[14px] font-medium">
                ID Documents
              </p>
              {/* <p className="text-[12px] text-gray-02 flex items-center">
                Status:
                {filteredId?.map((chi: any, idx: number) => (
                  <RazorBadgeTwo
                    key={idx}
                    className={`text-[14px] ml-[8px] !py-[4px] !px-[12px]
                     ${
                       chi?.status === "GREEN"
                         ? "success"
                         : chi?.status === "RED"
                         ? "failed"
                         : ""
                     }`}
                    text={chi?.status === "GREEN" ? "approved" : "rejected"}
                  />
                ))}
              </p> */}
            </div>
            {/* Current upload */}
            <div className=" mt-[8px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-[30px] justify-around">
                {filteredId?.length === 0 ? (
                  <div className="space-y-[8px] mx-auto">
                    <div className="w-[350px] h-[250px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box">
                      <RazorImageFallback loadSize={45} url={" "}>
                        <figure className="size-full text-gray-02">
                          No file found
                        </figure>
                      </RazorImageFallback>
                    </div>
                    <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                      <p className="">No upload</p>
                      <p className="inline-flex items-center">
                        Date Uploaded: ---
                      </p>
                    </div>
                  </div>
                ) : (
                  filteredId?.map((item: any, idx: number) => (
                    <div key={idx} className="space-y-[8px] mx-auto">
                      <ZoomableImage
                        src={item?.file_path?.[1]}
                        alt={item?.document_type}
                        width={400}
                        height={450}
                        zoomLevel={1.3}
                        zoomWindowSize={400}
                        onClick={() => {
                          context?.setDocumentModal({
                            visible: true,
                            url: item?.file_path?.[1],
                            doc_name: item?.metadata?.fileName,
                            file_name: item?.document_type,
                            file_sizee: item?.metadata?.fileSize,
                            status: item?.status,
                            date: item?.updated_at,
                          });
                        }}
                        containerClassName="w-[350px] h-[250px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box"
                      />
                      <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                        <p className="">
                          {item?.document_sub_type?.replace("_", " ")}
                        </p>
                        <p className="inline-flex items-center">
                          Date Uploaded:{" "}
                          {
                            <RazorDateTime
                              date={item?.updated_at}
                              hideAgo
                              className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                            />
                          }
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <div className="border border-[#e6e6e6] rounded-lg pb-[60px]">
            <div className="flex justify-between items-center border-[#e6e6e6] border-b py-[14px] px-[35px]">
              <p className="text-gray-01 text-[14px] font-medium">
                Liveliness Check
              </p>
              {/* <p className="text-[12px] text-gray-02 flex items-center">
                Status:
                {filteredSelfie?.map((chi: any, idx: number) => (
                  <RazorBadgeTwo
                    key={idx}
                    className={`text-[14px] ml-[8px] !py-[4px] !px-[12px]
                     ${
                       chi?.status === "GREEN"
                         ? "success"
                         : chi?.status === "RED"
                         ? "failed"
                         : ""
                     }`}
                    text={chi?.status === "GREEN" ? "approved" : "rejected"}
                  />
                ))}
              </p> */}
            </div>

            <div className=" mt-[8px]">
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-[30px] justify-around">
                {filteredSelfie?.length === 0 ? (
                  <div className="space-y-[8px] mx-auto">
                    <div className="size-[260px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box">
                      <RazorImageFallback loadSize={45} url={" "}>
                        <figure className="size-full text-gray-02">
                          No file found
                        </figure>
                      </RazorImageFallback>
                    </div>
                    <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                      <p className="">No upload</p>
                      <p className="inline-flex items-center">
                        Date Uploaded: ---
                      </p>
                    </div>
                  </div>
                ) : (
                  filteredSelfie?.map((item: any, idx: number) => (
                    <div key={idx} className="space-y-[8px] mx-auto">
                      <ZoomableImage
                        src={item?.file_path?.[1]}
                        alt={item?.document_type}
                        width={400}
                        height={450}
                        zoomLevel={1.3}
                        zoomWindowSize={400}
                        onClick={() => {
                          context?.setDocumentModal({
                            visible: true,
                            url: item?.file_path?.[1],
                            doc_name: item?.metadata?.fileName,
                            file_name: item?.document_type,
                            file_sizee: item?.metadata?.fileSize,
                            status: item?.status,
                            date: item?.updated_at,
                          });
                        }}
                        containerClassName="size-[260px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box"
                      />
                      <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                        <p className="">Current Upload</p>
                        <p className="inline-flex items-center">
                          Date Uploaded:{" "}
                          {
                            <RazorDateTime
                              date={item?.updated_at}
                              hideAgo
                              className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                            />
                          }
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </main>
      </AccordionBox>
    </>
  );
}
